export enum EnumEnrollmentState {
  "draft" = "draft",
  "published" = "published",
  "pending" = "pending",
  "active" = "active",
  "closed" = "closed",
}
